var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 396.1",
    style: {
      enableBackground: "new 0 0 512 396.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,142.2L134.7,95l12.8-2c20-3.1,38.4-13.2,51.8-28.6c13.5-15.6,20.9-35.5,20.9-56.1V0l-54.2,4.8 c-17.7,1.6-33.8,11.6-43,26.8l-12.6,20.8L97.2,31.7C88,16.4,71.9,6.4,54.2,4.8L0,0v8.3c0,20.6,7.4,40.6,20.9,56.1 C34.3,79.8,52.7,90,72.7,93l12.8,2l-0.2,32.3c0,97.6,66,182.1,159,206.5c7.9-41.3,28.6-72.1,30-74.1l12.4,8.5l12.4,8.5 c-0.4,0.6-40.6,60.8-23.4,119.5c27.5-13.5,48.5-36.6,62.4-68.9c12.5-29,14.3-54.8,14.3-55.1l0.6-8.8l8-3.8 c31.1-14.6,56.1-39.9,70.6-71l27.2,12.6c-16.2,35-43.5,63.7-77.4,81.8c-1.4,9.8-4.6,26.8-11.7,46C449.4,300.9,506,227.6,512,142.2 H135z M372,201.1c-8.3,0-15-6.7-15-15s6.7-15,15-15s15,6.7,15,15S380.3,201.1,372,201.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhaleIcon);
export default __webpack_public_path__ + "static/media/whale_icon.11c64621.svg";
export { ForwardRef as ReactComponent };